import React from 'react';
import { SpinnerBar, SpinnerContainer } from './Spinner.styles';

export const Spinner = () => {
  return (
    <SpinnerContainer>
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
      <SpinnerBar />
    </SpinnerContainer>
  );
};
